import React, { useEffect } from "react";
import { connect } from "react-redux";

import Typography from "@material-ui/core/Typography";
import GridItem from "../../components/UI/Grid/GridItem";
import GridContainer from "../../components/UI/Grid/GridContainer";
import axios from "../../axios/axios-football";
import * as actions from "../../store/actions/index";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import UserActivityGraph from "../../components/UI/Graphs/UserActivityGraph"
import UserActivityMap from "./UserActivityMap"

const UserActivity = props => {
  const { onFetchUserActivity, userActivity } = props;
  useEffect(() => {
    if(userActivity.length === 0) {
      onFetchUserActivity();
    }
  }, []);

  return (
    <div>
      <Typography align="center" variant="h6">User Activity Map, includes Space Station Orbiting</Typography>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <UserActivityMap />
        </GridItem>
        {/* <GridItem xs={12} sm={6} md={12}>
          <UserActivityGraph graphData={props.userActivity} />
        </GridItem> */}
      </GridContainer>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    userActivity: state.football.userActivity
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchUserActivity: () => dispatch(actions.fetchUserActivity())
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(UserActivity, axios));

// n2yo api QR5KEC-B8T657-392L9X-47EM
// https://www.n2yo.com/rest/v1/satellite/tle/43922&apiKey=QR5KEC-B8T657-392L9X-47EM
// https://www.n2yo.com/satellite/?s=43922
// https://www.celestrak.com/NORAD/elements/active.txt
